import React, { useCallback, useState, useContext } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import cn from 'clsx'
import { PackageOptionView } from 'selectors/cart/cartSelectors'
import { OfferPackageOptionView } from 'selectors/offerPageSelectors'
import LePackageUpgradeColumnHeader from './LePackageUpgradeColumnHeader'
import LePackageUpgradeColumnFooter from './LePackageUpgradeColumnFooter'
import LePackageUpgradeColumnScrollable from './LePackageUpgradeColumnScrollable'
import GeoContext from 'contexts/geoContext'

const SlideModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
`

const StickyPanels = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: ${rem(20)};
`

const SlidePanels = styled(StickyPanels)`
  overflow: hidden;

  &.scroll {
    overflow-y: scroll;
  }

  /* Remove scrollbar */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }

  &--scroll-container {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`

interface Props {
  packageUpgrade: PackageOptionView;
  selectedPackage: OfferPackageOptionView;
  hasFlightsSelected?: boolean;
  onUpgrade: () => void;
  onNoThanks: () => void;
}

function LePackageUpgradeCardTwoColumnsVariantDesktop({
  packageUpgrade,
  selectedPackage,
  hasFlightsSelected,
  onUpgrade,
  onNoThanks,
}: Props) {
  const selectedPackageInclusionsCountV2 = selectedPackage.package.inclusionsV2?.length || 0
  const packageUpgradeInclusionsCountV2 = packageUpgrade.package.inclusionsV2?.length || 0

  const hasMoreInclusionsV2 = packageUpgradeInclusionsCountV2 > selectedPackageInclusionsCountV2
  const isDifferentRoom = packageUpgrade.package.roomType?.id !== selectedPackage?.package.roomType?.id

  const [viewMoreDetails, setViewMoreDetails] = useState(false)
  const onViewDetails = useCallback(() => { setViewMoreDetails(!viewMoreDetails) }, [viewMoreDetails])

  const { showTaxExclusivePrices } = useContext(GeoContext)

  const selectedPkgPrice = showTaxExclusivePrices ? selectedPackage.hotelPrice : selectedPackage.hotelPrice + (selectedPackage.propertyFees || 0)
  const selectedPkgPriceWithFlights = hasFlightsSelected && selectedPackage.flightPrice && selectedPackage.flightsAvailable ? selectedPkgPrice + selectedPackage.flightPrice : selectedPkgPrice

  const upgradePkgPrice = showTaxExclusivePrices ? packageUpgrade.price : packageUpgrade.price + (packageUpgrade.package.propertyFees || 0)
  const upgradePkgPriceWithFlights = hasFlightsSelected && packageUpgrade.flightPrice && packageUpgrade.flightsAvailable ? upgradePkgPrice + packageUpgrade.flightPrice : upgradePkgPrice

  return (
    <SlideModalContent>
      <StickyPanels>
        <LePackageUpgradeColumnHeader pkg={selectedPackage.package} />
        <LePackageUpgradeColumnHeader isUpgrade pkg={packageUpgrade.package} hasMoreInclusions={hasMoreInclusionsV2} isDifferentRoom={isDifferentRoom} />
      </StickyPanels>
      <SlidePanels className={cn({ scroll: viewMoreDetails })}>
        <LePackageUpgradeColumnScrollable pkg={selectedPackage.package} />
        <LePackageUpgradeColumnScrollable pkg={packageUpgrade.package} />
      </SlidePanels>
      <StickyPanels>
        <LePackageUpgradeColumnFooter
          pkg={selectedPackage.package}
          totalValue={selectedPkgPriceWithFlights}
          showDetailsToggle={!viewMoreDetails}
          onViewDetails={onViewDetails}
          onNoThanks={onNoThanks}
        />
        <LePackageUpgradeColumnFooter
          pkg={packageUpgrade.package}
          totalValue={upgradePkgPriceWithFlights}
          priceDifference={packageUpgrade.priceDifference}
          showDetailsToggle={!viewMoreDetails}
          onViewDetails={onViewDetails}
          onUpgrade={onUpgrade}
        />
      </StickyPanels>
    </SlideModalContent>
  )
}

export default LePackageUpgradeCardTwoColumnsVariantDesktop
